(function() {
    // 注册组件
    SR.component.extend('tab', tab);
    function tab() {
        SR.dom.$body.on('click', '.J_tabToggle', function(e) {
            e.preventDefault();
            var $target = $(e.target);
            if (!$target.hasClass('tab-item') || $target.hasClass('active')) {
                return;
            }
            var $tabWrap = $(this).parents('.sr-tab-wrap');
            var $tab = $tabWrap.find('.sr-tab');
            var currentWrapH = $tab.height();
            $tabWrap.css({'height': currentWrapH});

            var index = $target.index();
            var $tabs = $tabWrap.find('.tab-item');
            var $panel = $tabWrap.find('.panel');

            $tabs.removeClass('active');
            $target.addClass('active');
            $panel.removeClass('show').eq(index).addClass('show');

            var nextWrapH = $tab.height();
            $tabWrap.css({'height': nextWrapH});
        });
    }
})();